import axios from '../config/axios';

const BASE = '/api/scribing/api/analytics';

export const analyticsService = {
  async getOverview(days = 7) {
    const res = await axios.get(`${BASE}/overview`, { params: { days } });
    return res.data;
  },
  async getDaily(days = 7) {
    const res = await axios.get(`${BASE}/daily`, { params: { days } });
    return res.data;
  },
  async getModels(days = 7) {
    const res = await axios.get(`${BASE}/models`, { params: { days } });
    return res.data;
  },
  async getEndpoints(days = 7) {
    const res = await axios.get(`${BASE}/endpoints`, { params: { days } });
    return res.data;
  },
  async getRequests(limit = 10, offset = 0, filters: any = {}) {
    const res = await axios.get(`${BASE}/requests`, { params: { limit, offset, ...filters } });
    return res.data;
  },
  async getRequest(id: string) {
    const res = await axios.get(`${BASE}/request/${id}`);
    return res.data;
  },
  async getDashboard(days = 7) {
    const res = await axios.get(`${BASE}/dashboard`, { params: { days } });
    return res.data;
  },
  async export(days = 7, format = 'json') {
    const res = await axios.get(`${BASE}/export`, { params: { days, format } });
    return res.data;
  }
  ,
  // Hourly tokens for a given date (YYYY-MM-DD)
  async getHourlyTokens(date: string, apiKey?: string) {
    const res = await axios.get(`${BASE}/hourly-tokens`, {
      params: { date },
      headers: apiKey ? { Authorization: `Bearer ${apiKey}` } : undefined,
    });
    return res.data;
  },
  // Token usage (individual requests) within a date range
  async getTokenUsage(start_date: string, end_date: string, apiKey?: string) {
    const res = await axios.get(`${BASE}/token-usage`, {
      params: { start_date, end_date },
      headers: apiKey ? { Authorization: `Bearer ${apiKey}` } : undefined,
    });
    return res.data;
  },
  // Daily complete analytics with pagination and filtering
  async getDailyComplete(options: {
    date?: string;
    start_date?: string;
    end_date?: string;
    page?: number;
    per_page?: number;
    model?: string;
    status?: number;
    apiKey?: string;
  }) {
    const { apiKey, ...params } = options;
    const res = await axios.get(`${BASE}/daily-complete`, {
      params,
      headers: apiKey ? { Authorization: `Bearer ${apiKey}` } : undefined,
    });
    return res.data;
  }
};

export default analyticsService;
